import React, { Component, isValidElement } from 'react';
import { API_URL } from '../../constants/api';
import { apiBatchRequest, apiPost } from '../../utils/api_service';
import { ShowToast, toastType } from '../../utils/toast-service';
import commonLabels from '../../constants/messageConstants';
import PageHeader from '../common/PageHeader';
import PageFilter from '../common/PageFilter';
import { GridTable } from '../common/Table/Table';
import { applyFilterOnData, cloneDeep, getCurrentPayCycle, IsSectionVisible, removeDuplicates, UpdateColumnWithConfiguration } from '../../utils/helper';
import { complianceColumn } from '../../constants/MockData';
import { IconButton, Tooltip, Button } from '@material-ui/core';
import { controlType } from '../../constants/common';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import moment from 'moment';
import store from '../../store/appStore';
import { SECTIONS } from '../../constants/appConstants';
import ConfirmDialog from '../common/Dailogbox/confirmDailog';

export class AllocationCompliance extends Component {
  constructor() {
    super();
    this.state = {
      payPeriodMasterData: [],
      complianceData: [],
      selectedData: [],
      responsePayPeriodData: [],
      isPopupOpen: false,
      sendEmailToAll: false,
      confirmationMessage: '',
      updateData: undefined,
      configuration: [],
      periodStartDate: null,
      periodEndDate: null,
      defaultSelectedData: [],
      responseComplianceData: [],
      employeeMasterData: [],
      complianceStatus: [],
      row: undefined
    };
  }

  componentDidMount() {
    this.LoadData();
  }

  onFilterChange = (selectedData) => {
    let periodStartDate; let periodEndDate;
    const selectedPayPeriod = selectedData.find((x) => x.key === 'payPeriod') || {};
    const { defaultSelectedData } = this.state;
    if (selectedPayPeriod.selected === undefined) {
      this.setState({
        selectedData: defaultSelectedData
      });
    } else {
      if (
        selectedPayPeriod &&
        selectedPayPeriod.selected
      ) {
        periodStartDate = selectedPayPeriod.selected.periodStartDate;
        periodEndDate = selectedPayPeriod.selected.periodEndDate;
      }
      if (selectedData && selectedData.filter(x => x.key === 'payPeriod') !== undefined &&
        moment(periodStartDate).format('MM/DD/YYYY') !==
        moment(this.state.periodStartDate).format('MM/DD/YYYY')) {
        this.setState({
          selectedData: selectedData || [],
          periodStartDate: moment(periodStartDate).format('MM/DD/YYYY'),
          periodEndDate: moment(periodEndDate).format('MM/DD/YYYY')
        }, () => {
          this.GetComplianceData(periodStartDate, periodEndDate, selectedData);
        });
      } else {
        const { responseComplianceData } = this.state;
        const filteredData = applyFilterOnData(
          [...responseComplianceData],
          selectedData
        );

        this.setState({
          complianceData: filteredData || [],
          selectedData: selectedData || [],
          periodStartDate: moment(periodStartDate).format('MM/DD/YYYY'),
          periodEndDate: moment(periodEndDate).format('MM/DD/YYYY')
        });
      }
    }
  };

  GetComplianceData = (periodStartDate, periodEndDate, selectedData) => {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Allocation.GetAllocationComplianceDetail + '?periodStartDate=' + moment(periodStartDate).format('MM/DD/YYYY') + '&periodEndDate=' + moment(periodEndDate).format('MM/DD/YYYY'),
        key: 'complianceData'
      }
    ])
      .then(
        ({
          complianceData
        }) => {
          this._asyncRequest = null;
          if (complianceData.success !== true) {
            ShowToast(
              commonLabels.somethingWrong,
              toastType.ERROR,
              5000,
              500,
              'Server error'
            );
          } else {
            this.setState({
              complianceData: applyFilterOnData(cloneDeep(complianceData.data || []), selectedData),
              configuration: complianceData.config,
              selectedData: selectedData || [],
              periodStartDate: moment(periodStartDate).format('MM/DD/YYYY'),
              periodEndDate: moment(periodEndDate).format('MM/DD/YYYY'),
              responseComplianceData: complianceData.data || []
            });
          }
        }
      )
      .catch(() => {
        this._asyncRequest = null;
      });
  }

  LoadData() {
    const selectedData = [];
    const date = getCurrentPayCycle();
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Allocation.GetPayPeriod,
        key: 'payPeriodMasterData'
      },
      {
        url: API_URL.Allocation.GetAllocationComplianceDetail + '?periodStartDate=' + date[1] + '&periodEndDate=' + date[0],
        key: 'complianceData'
      },
      {
        url: API_URL.Employee.GetEmployeeMasterData + '?showInActive=true',
        key: 'employeeMasterData'
      },
      {
        url: API_URL.Allocation.GetComplianceStatus,
        key: 'complianceStatus'
      }
    ])
      .then(
        ({
          payPeriodMasterData,
          complianceData,
          employeeMasterData,
          complianceStatus
        }) => {
          this._asyncRequest = null;
          if (complianceData.success !== true) {
            ShowToast(
              commonLabels.somethingWrong,
              toastType.ERROR,
              5000,
              500,
              'Server error'
            );
          } else {
            selectedData.push(
              {
                key: 'payPeriod',
                selected: (payPeriodMasterData.data.find(x => x.payPeriod === (date[1] + '-' + date[0])) || {})
              }
            );
            selectedData.push();
            this.setState({
              complianceData: applyFilterOnData(cloneDeep(complianceData.data || []), selectedData),
              responsePayPeriodData: cloneDeep(payPeriodMasterData.data || []).filter(x => x.isMarketYearEndBonus !== true),
              payPeriodMasterData: cloneDeep(payPeriodMasterData.data || []).filter(x => x.isMarketYearEndBonus !== true),
              configuration: complianceData.config,
              selectedData: selectedData || [],
              defaultSelectedData: cloneDeep(selectedData),
              periodStartDate: date[1],
              periodEndDate: date[0],
              employeeMasterData: employeeMasterData.data,
              responseComplianceData: complianceData.data || [],
              complianceStatus: complianceStatus.data || []
            });
          }
        }
      )
      .catch(() => {
        this._asyncRequest = null;
      });
  }

  openPopup = (isAll, row) => {
    const msg = isAll ? 'Are you sure to send reminder email of Allocations Due to all employees who have not completed the Allocations?' : 'Are you sure to send reminder email of Allocations Due to the selected employee?';
    this.setState({
      // confirmationMessage: <>Are you sure you are done with all Allocations changes till the current pay cycle? If yes, please click on the <b>Submit</b> button else click on <b>Cancel</b> button.</>,
      confirmationMessage: <>{msg} </>,
      isPopupOpen: true,
      sendEmailToAll: isAll,
      row: row
    });
  }

  onPopupClickHandle = (isYes) => {
    if (isYes) {
      const { sendEmailToAll, row } = this.state;
      if (sendEmailToAll) {
        this.sendComplianceReminderEmailToAll();
      } else {
        this.sendComplianceReminderEmail(row);
      }
    } else {
      this.setState({
        confirmationMessage: '',
        isPopupOpen: false
      });
    }
  }

  sendComplianceReminderEmailToAll = () => {
    const { responseComplianceData } = this.state;
    const applicableEmployees = responseComplianceData.filter(x => x.isCompleted !== true);
    if (applicableEmployees && applicableEmployees.length > 0) {
      const complianceData = {
        date: applicableEmployees[0]?.allocationDueDate,
        email: applicableEmployees?.map(x => x.userEmail).join('|')
      };

      apiPost({
        url: API_URL.Users.sendComplianceReminderEmail,
        params: complianceData
      }).then(({ data: response }) => {
        if (response.success) {
          ShowToast('Reminder email send successfully to all.', toastType.SUCCESS, 5000, 500);
          this.setState({
            isSave: false,
            confirmationMessage: '',
            isPopupOpen: false,
            row: undefined
          });
          // this.loadData();
        } else {
          ShowToast('Something went wrong.', toastType.ERROR, 5000, 500);
          this.setState({
            isSave: false,
            confirmationMessage: '',
            isPopupOpen: false,
            row: undefined
          });
        }
      });
    }
  }

  sendComplianceReminderEmail = (row) => {
    const date = getCurrentPayCycle();
    const email = (((store.getState() || {}).auth || {}).account || {}).username || '';
    const complianceData = {
      date: row.allocationDueDate, // date[0],
      email: row.userEmail // email
    };
    apiPost({
      url: API_URL.Users.sendComplianceReminderEmail,
      params: complianceData
    }).then(({ data: response }) => {
      if (response.success) {
        ShowToast('Reminder email send successfully.', toastType.SUCCESS, 5000, 500);
        // this.loadData();
        this.setState({
          isSave: false,
          confirmationMessage: '',
          isPopupOpen: false,
          row: undefined
        });
      } else {
        ShowToast('Something went wrong.', toastType.ERROR, 5000, 500);
        this.setState({
          isSave: false,
          confirmationMessage: '',
          isPopupOpen: false,
          row: undefined
        });
      }
    });
  }

  renderActionColumn = (row) => {
    return (
      <>
        { IsSectionVisible(SECTIONS.ALLOCATION_COMPLIANCE, 0, SECTIONS.ADD_EDIT) && row.isCompleted === false
          ? <Tooltip title="Send Reminder">
            <IconButton
              aria-label={'refreshData'}
              size="small"
              onClick={() => {
                // this.sendComplianceReminderEmail(row);
                this.openPopup(false, row);
              }}
            >
              <MailOutlineIcon fontSize="small" size="small" />
            </IconButton>
          </Tooltip>
          : ''
        }
      </>
    );
  };

  render() {
    const { isPopupOpen, confirmationMessage, complianceData, payPeriodMasterData, selectedData, configuration, defaultSelectedData, employeeMasterData, complianceStatus } = this.state;
    return (
      <>
        {isPopupOpen && (
          <ConfirmDialog
            IsOpen={isPopupOpen}
            Message={confirmationMessage}
            Title="Reminder Email Confirmation"
            OnHandelClick={(isValid) => {
              if (isValid) {
                this.onPopupClickHandle(isValid);
              } else {
                this.onPopupClickHandle(isValid);
              }
            }}
            AgreeText="Send Email"
            DisAgreeText="Cancel"
          />
        )}
        {<>
          <PageHeader title="Compliance"></PageHeader>
          <PageFilter
            autoFilter={false}
            filterAlwaysVisible={true}
            onFilterChanged={this.onFilterChange}
            filterConfig={[
              {
                multiple: false,
                type: controlType.DropDown,
                source: removeDuplicates(payPeriodMasterData, 'payPeriod'),
                key: 'payPeriod',
                placeholder: 'Pay Period',
                title: 'Pay Period',
                ignoreSort: true
              },
              {
                multiple: true,
                type: controlType.DropDown,
                source: employeeMasterData,
                key: 'employeeName',
                placeholder: 'Search Employee',
                title: 'Employee'
              },
              {
                multiple: true,
                type: controlType.DropDown,
                source: complianceStatus,
                key: 'complianceStatus',
                placeholder: 'Search Status',
                title: 'Status'
              }
            ]}
            gridColumn={3}
            defaultSelectedData={defaultSelectedData}
            selectedData={selectedData}
          ></PageFilter>
          {IsSectionVisible(SECTIONS.ALLOCATION_COMPLIANCE, 0, SECTIONS.ADD_EDIT) && <div className="row table-list-container">
            <Button
              variant="contained"
              color="primary"
              size="small"
              className='pull-right'
              onClick={() => {
                this.openPopup(true, undefined);
                // this.sendComplianceReminderEmailToAll();
              }}
            >
              Send Reminder to All
            </Button>
          </div>
          }
          <div className="row table-list-container">
            <GridTable
              columns={UpdateColumnWithConfiguration(
                complianceColumn,
                configuration
              )}
              data={complianceData || []}
              renderActionColumn={this.renderActionColumn}
            ></GridTable>
          </div>
        </>}
      </>
    );
  }
}

export default AllocationCompliance;
